import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import UnderConstruction from "./pages/UnderConstruction";

// Imports Profiling Steps 
import Step1 from "./pages/Step1";
import Step2 from "./pages/Step2";
import Step3 from "./pages/Step3";
import Step4 from "./pages/Step4";
import Step5 from "./pages/Step5";
import Step6 from "./pages/Step6";
import Step7 from "./pages/Step7";
import Step8 from "./pages/Step8";
import Step9 from "./pages/Step9";
import Appreciate from "./pages/Appreciate";

// Imports Learning Style 
import HelloStyle from "./pages/learning_style/HelloStyle";
import Style1 from "./pages/learning_style/Style1"; 
import Style2 from "./pages/learning_style/Style2"; 
import Style3 from "./pages/learning_style/Style3"; 
import Style4 from "./pages/learning_style/Style4"; 
import SummaryStyle from "./pages/learning_style/SummaryStyle"; 

// Imports Teaching Experience)
import HelloTeachingExperience from "./pages/teaching_experience/HelloTeachingExperience";
import Exp1 from "./pages/teaching_experience/Exp1";
import Exp2 from "./pages/teaching_experience/Exp2"; 
import Exp3 from "./pages/teaching_experience/Exp3"; 
import Exp4 from "./pages/teaching_experience/Exp4"; 
import Exp5 from "./pages/teaching_experience/Exp5"; 
import Exp6 from "./pages/teaching_experience/Exp6"; 
import Exp7 from "./pages/teaching_experience/Exp7"; 
import TeachingExperienceSummary from "./pages/teaching_experience/TeachingExperienceSummary"; 

// Imports Digital Readiness)
import HelloDR from "./pages/digital-readiness/HelloDR";
import DRStep1 from "./pages/digital-readiness/DRStep1";
import DRStep2 from "./pages/digital-readiness/DRStep2";
//import Dr3 from "./pages/digital-readiness/Exp3"; 
//import Dr4 from "./pages/digital-readiness/Exp4"; 
//import Dr5 from "./pages/digital-readiness/Exp5"; 
//import Dr6 from "./pages/digital-readiness/Exp6"; 
//import Dr7 from "./pages/digital-readiness/Exp7"; 
//import DigitalReadinessSummary from "./pages/digital-readiness/digital-readinessSummary"; 

// ... (ProtectedRoute function)
// 🔒 ProtectedRoute agar halaman tidak bisa diakses tanpa login
const ProtectedRoute = ({ children }) => {
const student = localStorage.getItem("student");
return student ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />

        {/* Step-by-step profiling (protected) */}
        <Route path="/Step1" element={<ProtectedRoute> <Step1 /> </ProtectedRoute>}/>
        <Route path="/Step2" element={<ProtectedRoute> <Step2 /> </ProtectedRoute>}/>
        <Route path="/Step3" element={<ProtectedRoute> <Step3 /> </ProtectedRoute>}/>
        <Route path="/Step4" element={<ProtectedRoute> <Step4 /> </ProtectedRoute>}/>
        <Route path="/Step5" element={<ProtectedRoute> <Step5 /> </ProtectedRoute>}/>
        <Route path="/Step6" element={<ProtectedRoute> <Step6 /> </ProtectedRoute>}/>
        <Route path="/Step7" element={<ProtectedRoute> <Step7 /> </ProtectedRoute>}/>
        <Route path="/underconstruction" element={<UnderConstruction />} />
        <Route path="/Step8" element={<ProtectedRoute> <Step8 /> </ProtectedRoute>}/>
        <Route path="/Step9" element={<ProtectedRoute> <Step9 /> </ProtectedRoute>}/>
        <Route path="/Appreciate" element={<ProtectedRoute> <Appreciate /> </ProtectedRoute>}/>

        {/* Dashboard (protected) */}
        <Route path="/dashboard" element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>}/>
        
        {/* ======================================================= */}
        {/* RUTE LEARNING STYLE */}
        {/* ======================================================= */} 
        <Route path="/learning-style/hello-style" element={<ProtectedRoute> <HelloStyle /> </ProtectedRoute>} />
        <Route path="/learning-style/style1" element={<ProtectedRoute> <Style1 /> </ProtectedRoute>} />
        <Route path="/learning-style/style2" element={<ProtectedRoute> <Style2 /> </ProtectedRoute>} />
        <Route path="/learning-style/style3" element={<ProtectedRoute> <Style3 /> </ProtectedRoute>} />
        <Route path="/learning-style/style4" element={<ProtectedRoute> <Style4 /> </ProtectedRoute>} />
        
        {/* Rute Summary/Hasil Akhir yang baru */}
        <Route path="/learning-style/summary" element={<ProtectedRoute> <SummaryStyle /> </ProtectedRoute>} />

		{/* ======================================================= */}
        {/* RUTE TEACHING EXPERIENCE */}
        {/* ======================================================= */}
        <Route path="/teaching-experience/hello" element={<ProtectedRoute> <HelloTeachingExperience /> </ProtectedRoute>} />
        <Route path="/teaching-experience/exp1" element={<ProtectedRoute> <Exp1 /> </ProtectedRoute>} />
        <Route path="/teaching-experience/exp2" element={<ProtectedRoute> <Exp2 /> </ProtectedRoute>} />
		<Route path="/teaching-experience/exp3" element={<ProtectedRoute> <Exp3 /> </ProtectedRoute>} />
		<Route path="/teaching-experience/exp4" element={<ProtectedRoute> <Exp4 /> </ProtectedRoute>} />
        <Route path="/teaching-experience/exp5" element={<ProtectedRoute> <Exp5 /> </ProtectedRoute>} />
		<Route path="/teaching-experience/exp6" element={<ProtectedRoute> <Exp6 /> </ProtectedRoute>} />
		<Route path="/teaching-experience/exp7" element={<ProtectedRoute> <Exp7 /> </ProtectedRoute>} />
		
		{/* Rute Summary/Hasil Akhir yang baru */}
        <Route path="/teaching-experience/TeachingExperienceSummary" element={<ProtectedRoute> <TeachingExperienceSummary /> </ProtectedRoute>} />
		
		{/* ======================================================= */}
        {/* RUTE DIGITAL READINESS */}
        {/* ======================================================= */} 
        <Route path="/digital-readiness/HelloDR" element={<ProtectedRoute> <HelloDR /> </ProtectedRoute>} />
        <Route path="/digital-readiness/DRStep1" element={<ProtectedRoute> <DRStep1 /> </ProtectedRoute>} />
		<Route path="/digital-readiness/DRStep2" element={<ProtectedRoute> <DRStep2 /> </ProtectedRoute>} />
        <Route path="/learning-style/style3" element={<ProtectedRoute> <Style3 /> </ProtectedRoute>} />
        <Route path="/learning-style/style4" element={<ProtectedRoute> <Style4 /> </ProtectedRoute>} />
        
        {/* Rute Summary/Hasil Akhir yang baru */}
        <Route path="/learning-style/summary" element={<ProtectedRoute> <SummaryStyle /> </ProtectedRoute>} />
		
	 </Routes>
    </Router>
  );
}

export default App;